angular.module('impactx.catalog').controller('InternalCatalogSupplierCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$mdDialog',
    'CatApprovalService',
    '$redirect',
    'CatalogCheckinService',
    'TranslationService',
    'ConfirmationService',
    'CatalogActionsService',
    'ShopViewService',
    'ToolbarService',
    InternalCatalogSupplierCtrl]);

function InternalCatalogSupplierCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $mdDialog, CatApprovalService, $redirect,
                                     CatalogCheckinService, TranslationService, ConfirmationService, CatalogActionsService, ShopViewService, ToolbarService) {
    var self = this;
    self.init = function () {
        dataGen.getData($scope, {id: $routeParams.id}, "/catalog/viewinternalsupplier").then(function () {
            self.initToolbarButtons();
        });
    };
    self.init();

    self.doneForward = function () {
        CatApprovalService.forwardToApproval($scope.data.id, self.redirectToCatList);
    };

    this.release = function ()
    {
        CatApprovalService.release($scope.data.id, BackService.back);
    };

    self.checkIn = function () {
        var scope = {};
        CatalogCheckinService.checkIn(scope, $scope.data.id).then(function () {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(scope.trns.checkInStarted)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            self.redirectToCatalogList();
        })
    };

    self.redirectToCatalogList = function () {
        $redirect.redirectTo(null, "cataloglist");
    };

    self.deny = function () {
        CatalogActionsService.denyCheckedOut($scope.data.id, self.redirectToCatList);
    };

    self.stop = function (event) {
        CatApprovalService.stopCatalog($scope.data.id, BackService.back, event);
    };

    self.checkout = function () {
        var dataObj = {
            cat: $scope.data
        };
        dataGen.postAsForm($scope, dataObj, "/catalog/checkout").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.checkoutSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.checkoutDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.checkout, event, $scope.trns.checkoutWarning, $scope.trns.checkoutNow, $scope.trns.abort, $scope.trns.checkoutQuestion);
    };


    self.review = function () {
        $redirect.redirectTo(null, '/checkedoutcataloglist/' + $scope.data.id);
    };

    self.denyCheckedOutCatalog = function (ev) {
        var deny = $mdDialog.confirm()
            .title($scope.trns.discard)
            .textContent($scope.trns.discardChanges)
            .ariaLabel('denyCatalog')
            .targetEvent(ev)
            .ok($scope.trns.discard)
            .cancel($scope.trns.abort);

        $mdDialog.show(deny).then(function () {
            dataGen.postAsForm($scope, {catId: $scope.data.id}, '/catalog/deny/checkedoutcatalog');
            BackService.back();
        }, function () {
        });
    };

    self.replace = function () {
        CatalogActionsService.replace($scope.data.id);
    };

    self.replaceCatOnApprovalProcess = function (event) {
        CatalogActionsService.replaceOnApprovalProcess(event, $scope.data.id, $scope.trns);
    };

    self.replaceCatOnOwnEdit = function (event) {
        CatalogActionsService.replaceOnOwnEdit(event, $scope.data.id, $scope.trns);
    };

    self.delete = function () {
        CatalogActionsService.delete($scope.data.id);
    };

    self.getQualityManagementLink = function() {
        return "catalogqualitymanagement/" + $scope.data.id;
    };

    self.canAccessShopView = function () {
        return impactX.isDefined($scope, "data.canAccessShopView");
    };

    self.activateShopView = function () {
        ShopViewService.activateShopView({id: $scope.data.vcatId});
    };

    self.redirectToCatList = function () {
        $redirect.redirectTo(null, "/cataloglist");
    };

    self.canRunChangeProtocol = function() {
        return $scope.data && $scope.data.changeProtocol && $scope.data.changeProtocol.canRunChangeProtocol;
    };

    self.changeProtocolDialog = function(event) {
        CatalogActionsService.runChangeProtocolDialog(event, $scope.data.id)
    };

    self.extendLastDate = function(event) {
        CatalogActionsService.extendLastDate(event, $scope.data, $scope.trns).then(function (result) {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                .textContent(result.trns.extendSuccess)
                .position("bottom right")
                .hideDelay(10000)
            );
        });
    };

    self.initToolbarButtons = function () {
        $scope.buttonDefinition = [
            {
                label: $scope.trns.qualityManagement,
                linkFunction: self.getQualityManagementLink,
                type: 'link',
                process: 'Catalog'
            },
            {
                label: $scope.trns.update, action: self.replace, type: 'dialogaction', condition: function () {
                    return $scope.data.canReplace
                }
            },
            {
                label: $scope.trns.update,
                action: self.replaceCatOnApprovalProcess,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnApprovalProcess
                }
            },
            {
                label: $scope.trns.update,
                action: self.replaceCatOnOwnEdit,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReplaceOnOwnEdit
                }
            },
            {
                label: $scope.trns.review, action: self.review, type: 'dialogaction', condition: function () {
                    return $scope.data.canReview
                }
            },
            {
                label: $scope.trns.checkin, action: self.checkIn, type: 'dialogaction', condition: function () {
                    return $scope.data.canCheckIn
                }
            },
            {
                label: $scope.trns.checkout, action: self.checkoutDialog, type: 'dialogaction', condition: function () {
                    return $scope.data.canCheckout
                }
            },
            {
                label: $scope.trns.doneForward, action: self.doneForward, type: 'dialogaction', condition: function () {
                    return $scope.data.canDoneForward
                }
            },
            {
                label: $scope.trns.discard,
                action: self.denyCheckedOutCatalog,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canReview
                }
            },
            {
                label: $scope.trns.discard, action: self.delete, type: 'dialogaction', condition: function () {
                    return $scope.data.canDiscardFailedImport
                }
            },
            {
                label: $scope.trns.deny, action: self.deny, type: 'dialogaction', condition: function () {
                    return $scope.data.canDeny
                }
            },
            {
                label: $scope.trns.release, action: self.release, type: 'dialogaction', condition: function () {
                    return $scope.data.canRelease
                }
            },
            {
                label: $scope.trns.shopView,
                action: self.activateShopView,
                type: 'dialogaction',
                condition: self.canAccessShopView,
                process: 'Search'
            },
            {
                label: $scope.trns.extendLastDate,
                action: self.extendLastDate,
                type: 'dialogaction',
                condition: function () {
                    return $scope.data.canExtendLastDate
                }
            },
            {
                label: $scope.trns.changeProtocol,
                action: self.changeProtocolDialog,
                condition: self.canRunChangeProtocol,
                process: 'CatalogRunChangeRules'
            }
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
    };
}
